import React from "react";
import style from "./style.module.scss";
import PDFIcon from "../../../../../../assets/svg/icons/common/PDFIcon";

function Documents() {
  return (
    <div className={style.documents_section}>
      <div className={style.doc_heading}>
        <h5>Documents</h5>
      </div>

      <div className={style.doc_list}>
        <div className={style.doc_item}>
          <PDFIcon />
          <div className={style.doc_info}>
            <span className={style.doc_name}>Worksheet.pdf</span>
            <span className={style.doc_size}>2kb</span>
          </div>
        </div>

        <div className={style.doc_item}>
          <PDFIcon />
          <div className={style.doc_info}>
            <span className={style.doc_name}>Worksheet.pdf</span>
            <span className={style.doc_size}>2kb</span>
          </div>
        </div>

        <div className={style.doc_item}>
          <PDFIcon />
          <div className={style.doc_info}>
            <span className={style.doc_name}>Worksheet.pdf</span>
            <span className={style.doc_size}>2kb</span>
          </div>
        </div>

        <div className={style.doc_item}>
          <PDFIcon />
          <div className={style.doc_info}>
            <span className={style.doc_name}>Worksheet.pdf</span>
            <span className={style.doc_size}>2kb</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Documents;
